import { RiddleData } from '../types/riddle';
import { mockRiddleData } from './riddleData';

// For development, use mock data
export async function fetchRiddleData(): Promise<RiddleData[]> {
  return mockRiddleData;
}